let buttonToggle = document.getElementsByClassName('primary-slide-out');

if (buttonToggle) {
    let slideIn = document.getElementById('contact-slide-in');
    let slideInClose = document.getElementById('contact-slide-in-close');
    let slideInOverlay = document.getElementById('contact-slide-in__overlay');
    let body = document.getElementsByTagName('body');
    let form = slideIn.getElementsByClassName('wpcf7');
    let contactFormDiv = document.getElementById('contact-form');
    let thanks = document.getElementById('thank-you-message');
    let thanksClose = document.getElementById('thank-you-close');

    for (let i = 0; i < buttonToggle.length; i++) {
        buttonToggle[i].addEventListener('click', function() {
            body[0].classList.add('nav-open');
            slideIn.classList.add('open');
        })
    }



    slideInClose.addEventListener('click', function() {
        slideIn.classList.remove('open');
        body[0].classList.remove('nav-open');
    })

    slideInOverlay.addEventListener('click', function() {
        slideIn.classList.remove('open');
        body[0].classList.remove('nav-open');
    })
    
    form[0].addEventListener( 'wpcf7submit', function( event ) {
        contactFormDiv.remove();
        thanks.style.display = 'block';
    }, false );

    thanksClose.addEventListener('click', function() {
        slideIn.classList.remove('open');
        body[0].classList.remove('nav-open');
    })
}